import { createAction, props } from '@ngrx/store';

import { ManureOffer, ManureOfferModel } from '../../models/manure-offer.model';

export const sendManureOffer = createAction(
  '[Request] Send Manure Offer',
  props<{ request: ManureOffer }>(),
);

export const sendManureOfferSuccess = createAction(
  '[Request] Send Manure Offer Success',
  props<{ response: ManureOfferModel }>(),
);
